import { MouseEvent, MutableRefObject, useCallback, useEffect, useRef } from 'react';

import { IPopover, TPopoverModifiers } from '@gem/ui-kit';

import { useContextMenu } from 'APP/main/hooks/useContextMenu/useContextMenu';

interface IMessageContextMenuPresenterProps {
  reference: MutableRefObject<HTMLElement | null>;
}

interface IMessageContextMenuPresenter {
  popover: IPopover<HTMLElement>;
  modifiers: TPopoverModifiers;
  targetClick: HTMLElement | null;
}

export const useMessageContextMenuPresenter = ({
  reference,
}: IMessageContextMenuPresenterProps): IMessageContextMenuPresenter => {
  const { onContextMenu, modifiers, popover } = useContextMenu();

  const targetClickRef = useRef<HTMLElement | null>(null);

  const contextMenuHandler = useCallback(
    (event: Event) => {
      targetClickRef.current = event.target as HTMLElement;

      onContextMenu(event as unknown as MouseEvent<HTMLDivElement>);
    },
    [popover.isOpened]
  );

  useEffect(() => {
    if (!reference.current) {
      return;
    }

    popover.containerRef.current = reference.current;

    const referenceEl = reference.current;
    referenceEl.addEventListener('contextmenu', contextMenuHandler);
    referenceEl.addEventListener('click', popover.close);

    return () => {
      referenceEl?.removeEventListener('contextmenu', contextMenuHandler);
      referenceEl?.removeEventListener('click', popover.close);
    };
  }, [reference, contextMenuHandler]);

  return {
    popover,
    modifiers,
    targetClick: targetClickRef.current,
  };
};
